import { createSelector } from 'reselect';

import { PLAN_TIER } from '@wetransfer/transfer/constant/plan-tier';
import { isLoggedInFreeUser } from '@wetransfer/transfer/helper/user';
import type { State, UserState } from '@wetransfer/transfer/store/types';

export const selectUser = (state: State): UserState => state.user;

export const selectUserHasOnboarded = createSelector(
  selectUser,
  (user) => user.preferences.onboarded
);

export const selectUserIsLoggedIn = createSelector(selectUser, (user) =>
  Boolean(user.loggedIn)
);

export const selectUserIsVerified = createSelector(
  selectUser,
  (user) => user.isVerified
);

export const selectUserId = createSelector(selectUser, (user) => user.id);

export const selectUserPlanTier = createSelector(
  selectUser,
  (user: UserState | undefined): PLAN_TIER | undefined => user?.planTier
);

export const selectIsUnpaidUser = createSelector(
  selectUser,
  (user: UserState | undefined): boolean =>
    !user?.loggedIn || isLoggedInFreeUser(user)
);
